import React, { useMemo } from "react";
import Dashboard from "asset-metrics-dashboard";
import assetMetricsCmmsDataProvider from "../../dataProviders/assetMetricsCmmsDataProvider";

// Read configuration from environment variables
const apiKey = process.env.REACT_APP_LCCENGINE_API_KEY || '';
const metricsApiBase = process.env.REACT_APP_LCCENGINE_API_BASE || '';

const ReliabilityDashboardLayer = () => {
  const dataProvider = useMemo(() => assetMetricsCmmsDataProvider, []);

  return (
    <div className='row gy-4 p-24'>
      <style>
        {`
          .utilisation-dashboard-metrics .card .card-body h3 {
            font-size: 1.75rem !important;
          }
          .utilisation-dashboard-metrics span.badge.rounded-pill.bg-secondary-focus {
          color: #1f2937 !important;
          background-color: #e5e7eb !important;}
          .utilisation-dashboard-metrics .apexcharts-canvas {
          background-color: #ffffff !important;
          }
        `}
      </style>
      <div className="utilisation-dashboard-metrics">
        <Dashboard
          dataProvider={dataProvider}
          visibleKpis={["stoppageCountTotal", "stoppageCountTotal", "stoppageCountBreakdown", "stoppageHoursTotal",
            "stoppageHoursBreakdown", "percentageBreakdownEvents", "stoppagesPerThousandHours", "meanTimeBetweenStoppages",
            "meanTimeBetweenFailures", "meanTimeToFirstStoppageAfterPm", "meanTimeBetweenUnplannedStoppages",
            "availabilityIndex" ]}
          apiKey={apiKey}
          metricsApiBase={metricsApiBase}
          showSettings={false}
          onError={(message) => {
            console.error(message);
          }}
        />
      </div>
    </div>
  );
};

export default ReliabilityDashboardLayer;
